import script from "./CalendarEventSmall.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalendarEventSmall.vue?vue&type=script&setup=true&lang=ts"

import "./CalendarEventSmall.vue?vue&type=style&index=0&id=3e839eb5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e839eb5"]])

export default __exports__